import { basicClasses as _hotelTitleStyles } from './HotelTitle/style';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';

const {theme} = defaultTheme;

import {
  LESS_768_MEDIA_QUERY,
  MORE_768_MEDIA_QUERY,
  MORE_984_MEDIA_QUERY,
} from '../../consts/adaptive';

export const styles = {
    container: {
        color: theme.colorVariables.textDark,
        fontSize: 16,
        backgroundColor: theme.colorVariables.bgPrimary,
        position: 'relative',
    },
    titleBlock: {
        padding: [16, 0, 16],
    },
    breadcrumbsAndNameContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    mainLayout: {
        margin: '0 auto',
        maxWidth: 1280,
        padding: [0, 24],
        boxSizing: 'border-box'
    },
    mainLayoutHeader: {
      [LESS_768_MEDIA_QUERY]: {
        backgroundColor: theme.colorVariables.bgAccent,
      },
    },
    dark: {
        backgroundColor: theme.colorVariables.bgAccent,
    },
    postFilters: {
        marginTop: 40,
        marginBottom: -16,
    },
    mainLayoutMod: {},

    '@media screen and (max-width: 767px)': {
        mainLayout: {
            padding: [0, 10],
        },
        mainLayoutMod: {
            backgroundColor: theme.colorVariables.bgPrimary,
        },
    },

    [MORE_768_MEDIA_QUERY]: {
        container: {
            backgroundColor: theme.colorVariables.bgPrimary,
        },
        titleBlock: {
            paddingBottom: 20,
        },
    },
    [MORE_984_MEDIA_QUERY]: {
        titleBlock: {
            padding: [16, 0, 24],
            backgroundColor: '#fff',
            boxSizing: 'border-box',
        },
    },
};

export const hotelTitleStyles = {
    ..._hotelTitleStyles,
    container: {
        ..._hotelTitleStyles.container,
        display: 'flex',
        flexDirection: 'column',
    },
    hotelNameWrap: {
        ..._hotelTitleStyles.hotelNameWrap,
        lineHeight: '22px',
        fontWeight: 700,
    },
    hotelCategory: {
        ..._hotelTitleStyles.hotelCategory,
        marginRight: 4,

        '& .icon-star': {
            width: 12,
            height: 12,
        },
    },
    hotelName: {
        ..._hotelTitleStyles.hotelName,
        marginRight: 0,
    },
    linksContainer: {
        ..._hotelTitleStyles.linksContainer,
        display: 'flex',
        flexWrap: 'wrap',
        fontSize: 0, // для сокрытия запятой в мобильной версии
    },
    link: {
        ..._hotelTitleStyles.link,
        marginTop: 8,
        padding: [4, 12],
        fontSize: 14,
        border: '1px solid rgba(0, 120, 190, 0.25)',
        borderRadius: 2,
        backgroundColor: '#fff',

        '&:not(:last-child)': {
            marginRight: 8,
        },
    },
    [MORE_768_MEDIA_QUERY]: {
        hotelNameWrap: {
            fontSize: 20,
            lineHeight: '28px',
        },
        hotelCategory: {
            '& .icon-star': {
                width: 16,
                height: 16,
            },
        },
        hotelCategoryText: {
            marginRight: 4,
        },
    },
    [MORE_984_MEDIA_QUERY]: {
        container: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        hotelNameWrap: {
            marginRight: 16,
            fontSize: 24,
            lineHeight: 'normal',
        },
        hotelCategory: {
            marginRight: 8,

            '& .icon-star': {
                width: 20,
                height: 20,
            },
        },
        linksContainer: {
            display: 'block',
            flexWrap: 'unset',
            fontSize: 24,
        },
        link: {
            display: 'inline',
            marginTop: 0,
            padding: 0,
            fontSize: 'inherit',
            border: 0,

            '&:not(:last-child)': {
                marginRight: 0,
            },
        },
    },
};

export type ComponentJSSClasses = typeof styles;
